// extracted by mini-css-extract-plugin
module.exports = {"loc_position":"loc_position-13pwSB8M"};